import { ArrowUp } from "lucide-react";
import { Monogram } from "./Monogram";
import { ScrollReveal } from "./MaskedReveal";

const LEGAL = [
  { label: "Издател", testid: "footer-legal-publisher" },
  { label: "Поверителност", testid: "footer-legal-privacy" },
  { label: "Условия", testid: "footer-legal-terms" },
  { label: "Бисквитки", testid: "footer-legal-cookies" },
  { label: "Достъпност", testid: "footer-legal-accessibility" },
  { label: "Контакт", testid: "footer-legal-contact" },
];

export const Footer = () => (
  <footer className="relative z-[1] overflow-hidden bg-[#14110D] text-[#F4F1EA]" data-testid="footer">
    <div className="mx-auto max-w-[1440px] px-5 py-16 sm:px-8">
      <ScrollReveal>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Monogram className="h-9 w-9" />
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4F1EA]/50">Том I — MMXXVI</span>
          </div>
          <button
            data-testid="back-to-top-button"
            aria-label="Обратно нагоре"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="grid h-11 w-11 place-items-center rounded-full border border-[#F4F1EA]/25 transition-colors duration-300 hover:bg-[#C8402A] hover:border-[#C8402A]"
          >
            <ArrowUp className="h-4 w-4" />
          </button>
        </div>
      </ScrollReveal>

      <ScrollReveal delay={0.1}>
        <p className="mt-14 font-serif text-[clamp(2.6rem,9vw,8rem)] uppercase leading-[0.95] tracking-tight">
          Alex <span className="italic text-[#C8402A]">Cholakov</span>
        </p>
      </ScrollReveal>

      <div className="mt-14 flex flex-wrap items-center justify-between gap-6 border-t border-[#F4F1EA]/15 pt-8">
        <nav className="flex flex-wrap gap-x-7 gap-y-3">
          {LEGAL.map((l) => (
            <a
              key={l.label}
              href="#nachalo"
              onClick={(e) => e.preventDefault()}
              data-testid={l.testid}
              className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#F4F1EA]/60 transition-colors duration-300 hover:text-[#C8402A]"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#F4F1EA]/40">
          © MMXXVI — Всички права запазени
        </p>
      </div>
    </div>
  </footer>
);
